import { RegisterAuth } from '@carvana/core-auth';
import { RegisterExperiment } from '@carvana/core-experiment';
import { AnalyticsProvider } from '@carvana/eventable-clickstream';
import { QueryClientProvider } from '@tanstack/react-query';
import { MemoryRouter } from 'react-router-dom';

import ChatApp from 'components/ChatApp';

import { getAnalyticsConfig } from 'analytics/';
import queryClient from 'queries/queryClient';

import {
  AppConfigProvider,
  AuthenticationProvider,
  ChatContextProvider,
  ConversationProvider,
  CustomerProvider,
  ViewProvider,
} from 'providers/.';

import { CHAT_UI_SERVICE_NAME, CVNA_ENV } from 'constants/carvana';
import { DataDogLogger } from 'utils/dataDog';
import { getExperimentConfig } from 'utils/experiment';
import { combineProviders } from 'utils/hook';

// Provider configurations
const analyticsConfig = getAnalyticsConfig();

// Initialize CORE packages
RegisterAuth({ environment: CVNA_ENV, name: CHAT_UI_SERVICE_NAME });
RegisterExperiment(getExperimentConfig());

// Initialize DataDog Real User Monitoring (RUM)
DataDogLogger.init(CHAT_UI_SERVICE_NAME);

const App = () => {
  const providers = [
    AuthenticationProvider,
    AppConfigProvider,
    ChatContextProvider,
    ConversationProvider,
    CustomerProvider,
    ViewProvider,
  ];
  const CombinedProviders: React.FC<PropsWithChildren> = combineProviders(providers);
  return (
    <MemoryRouter>
      <AnalyticsProvider {...analyticsConfig}>
        <QueryClientProvider client={queryClient}>
          <CombinedProviders>
            <ChatApp />
          </CombinedProviders>
        </QueryClientProvider>
      </AnalyticsProvider>
    </MemoryRouter>
  );
};

export default App;
